import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-544c8606"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "batch-modal-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "batch-textarea-title"
}, [/*#__PURE__*/_createElementVNode("span", null, "复送后需用户登录领取方为复送成功"), /*#__PURE__*/_createElementVNode("span", null, "单次复送最多50条")], -1));
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BatchSureModal',
  props: {
    modalVisible: {
      type: Boolean,
      required: true
    },
    modalLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modalVisible', 'submitOk'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const closeModal = () => {
      emit('update:modalVisible', false);
    };
    const submitOk = () => {
      emit('submitOk', 'handle');
    };
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        class: "batch-modal",
        centered: "",
        closable: false,
        open: __props.modalVisible,
        confirmLoading: __props.modalLoading,
        maskClosable: false,
        cancelButtonProps: {
          disabled: __props.modalLoading
        },
        onCancel: closeModal,
        onOk: submitOk,
        width: "416px"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ExclamationCircleFilled), {
          class: "title-icon"
        }), _createTextVNode(" 请确认 ")]), _hoisted_2]),
        _: 1
      }, 8, ["open", "confirmLoading", "cancelButtonProps"]);
    };
  }
});